import React, { Component, createRef } from 'react';
import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Icons from '../../../../icon';
import './notification.css';
import { DISPLAY_ITEM, INVOICE_NOTIFICATION_STATUS, MODAL_CUSTOM_MESSAGE, ROUTE_LINK_LOCATION, Selected_Index, TWO_COLUMN_UPLOAD_COLUMN, UPLOAD_TYPES, HR_UPLOAD_TEMPLATE_ERRORS, NOTIFICATION_HAVE_EXTRACT, HAS_LIST_TAB } from '../../../../../constants/external-constants';
import { notificationActions } from '../../../../../store/common/header-navigation/header/notification.reducer';
import FormatDateComponent from '../../../date/format-date.component';
import DetailsModal from '../../../modal/details-modal/details-modal';
import { TablePagination } from '../../../details-table/table-pagination.component';
import ButtonIcon from "../../../../../components/button";
import { ConfirmationNotificationModal } from '../../../modal/confirmation-modal.component';
import { CONFIRMATION_VALUE } from '../../../../../utils/constant.utils';
import UploadNotification from './upload-notification.component';
import { NoSubscription } from '../../../../external/dashboard/no-subscription/no-subscription.component';
import { ListTabButton } from '../../../list-tab/list-tab-button.component';
import { TRANSLATIONS } from '../../../../../utils/constant.utils';
import { OutputRecordAction } from '../../../../../store/external/recharge-reducer/output-record.reducer/output-record.reducer';
import ModalContainer from '../../../modal/modal-container/modal-container.component';
import OutputRecordsInfo from '../../../../../components/external/recharge/output-records/modal/output-records-info.component';
class HeaderNotification extends Component {
    constructor(props) {
        super(props);
        this.wrapperRef = createRef();
        this.state={
            displayedItems: DISPLAY_ITEM.ten,
            showUploadButton: false,
            uploadTypeId: 0,
            selectedIndex: 0,
            errorUpload: {
                show: false,
                data: []
            },
            errorModal: {
                show: false,
                data: []
            },
            batchId: "",
            confirmDeleteModal: {
                show: false,
                dataId: 0,
                isDeleting: false
            },
             listTab: [
                {
                    "id": Selected_Index.i_Zero,
                    "label": "Details",
                    "hidden": false
                }
            ],
            modalTitle: '',
            showModalForm: false,
            modalIsLoading: false,
            selectedRecordData:null

        }
    }

    checkIfNotifClickedOutside = (e) => {
        const bellIcon = document.querySelector('.icon-bell');
        const bellUseElement = bellIcon.querySelector('use');

        if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target) && (e.target !== bellIcon && e.target !== bellUseElement)) {
            if (!this.state.confirmDeleteModal.show && !this.state.errorModal.show  
                && !this.state.errorUpload.show && !this.state.showModalForm) {
                this.setState({
                    displayedItems: DISPLAY_ITEM.ten
                });
                this.props.onClose();
            }
        }
    }
   
    componentDidMount() {
        window.addEventListener('mousedown', this.checkIfNotifClickedOutside);
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.checkIfNotifClickedOutside);
    }

    getStatusIconName = (statusKey) => {
        switch (statusKey) {
            case INVOICE_NOTIFICATION_STATUS.completed.key:
                return "check-circle-completed";
            case INVOICE_NOTIFICATION_STATUS.failed.key:               
                return "circle-close-failed";
            case INVOICE_NOTIFICATION_STATUS.completedwitherror.key:
                return "circle-exlamation-error";
            case INVOICE_NOTIFICATION_STATUS.inProgress.key:
            case INVOICE_NOTIFICATION_STATUS.pending.key:
                return "triangle-exlamation-inprogress";            
            default:
                return "";
        }
    }

    handleOutputRecord = async (recordId, value, uploadTypeId) => {  
        
       const { fetchOutputRecordById, fetchAttachment } = this.props;     

       if(parseInt(UPLOAD_TYPES.RechargingOutputRecordGeneration) === parseInt(uploadTypeId)) {
            this.setState({
                modalIsLoading: true,
                showModalForm: true, 
                modalTitle: `Output Record \u00A0\u00A0 Loading...`,
            })
            var data = await fetchOutputRecordById(recordId)
            var fetchedFiles = await fetchAttachment(recordId)

             const generatedFiles = fetchedFiles ? fetchedFiles.map(file => ({ 
                key: file.Key,
                name: file.FileName,
                filePath: file.FilePath
            })) : [];

            const recordDataWithFiles = {
                ...data,
                GeneratedFiles: generatedFiles
            };
            this.setState({
                modalIsLoading: false,
                modalTitle: `Output Record \u00A0\u00A0 ${data.OutputRecordStatus.toUpperCase()}`,
                selectedRecordData: recordDataWithFiles,
            })

            return
       }
        
        sessionStorage.setItem('tempRecordIdForDetailPage', recordId);
        const targetUrl = `${ROUTE_LINK_LOCATION.orderRecords}/${value}`;
        window.open(targetUrl, "_blank")
    }

    renderNotificationDetail = (dataList) => (
        <>
            {(dataList.subTitleHeader == "Invoice Number") &&
                (dataList.statusData.key == INVOICE_NOTIFICATION_STATUS.completed.key && dataList.uploadTypeId == UPLOAD_TYPES.InvoiceUpload) ||
                (dataList.uploadTypeId == UPLOAD_TYPES.InvoiceMatchAudit) ?
                <div className='header-notification__detail'>
                    <span>{dataList.subTitleHeader}: <span className='isLink' onClick={() => this.openNewTab(dataList)} >{dataList.subTitleData.value}</span> </span>
                </div>
                : (dataList.uploadTypeId == UPLOAD_TYPES.RechargeMappingInventory && dataList.mappingTitleHeader == "Mapping Type") ?
                    <div className='header-notification__detail'>
                        <span>{dataList.mappingTitleHeader}: {dataList.mappingTypeData}</span>
                    </div>
                : (dataList.uploadTypeId == UPLOAD_TYPES.HrUpload 
                  || dataList.uploadTypeId == UPLOAD_TYPES.DebitorUpload
                    || dataList.uploadTypeId == UPLOAD_TYPES.ArticleUpload) ?
                <div className='header-notification__detail'>
                    <span>{dataList.uploadTypeLabel}: {dataList.uploadType}</span>
                </div>
                : ''
               }
            {dataList.vendor && (
                <div className='header-notification__detail'>
                    <span>Vendor: {dataList.vendor}</span>
                </div>
            )}
            { (dataList.subTitleHeader === "Output Generation") &&
                <div className='header-notification__detail'>
                    <span>{dataList.subTitleHeader}: <span className='isLink' onClick={() => { 
                        this.handleOutputRecord(dataList.subTitleData.key, dataList.subTitleData.value,dataList.uploadTypeId)}}>
                            {dataList.subTitleData.value}</span> </span>
                </div>
            }
        </>
    );

    openNewTab(dataList) {
        window.open(`${dataList.subTitleData.link}`, "_blank");
    }

    renderNotificationStatus = (dataList) => (
        <div className='header-notification__status'>
            <span>Status:</span>
            {(dataList.statusData.key !== INVOICE_NOTIFICATION_STATUS.failed.key &&
             dataList.statusData.key !== INVOICE_NOTIFICATION_STATUS.completedwitherror.key) ? 
                <span className='header-notification__label'>{dataList.statusData.value.toLowerCase() === INVOICE_NOTIFICATION_STATUS.pending.value.toLowerCase() ? INVOICE_NOTIFICATION_STATUS.inProgress.value : dataList.statusData.value}</span> : 
                <>
                    <span className='header-notification__label'>{dataList.statusData.value} </span> <span className='vertical-line'>|</span>
                    <span className='custom-link' onClick={() => this.toggleViewError(dataList)}>View Error</span>
                </>
            }
        </div>
    );

    renderDeleteIcon = (dataList) => (
        (dataList.statusData.key !== INVOICE_NOTIFICATION_STATUS.inProgress.key && dataList.statusData.key !== INVOICE_NOTIFICATION_STATUS.pending.key) && 
        <div className='header-notification__delete-icon'>
            <Icons
                customClassName="icon-header-trash"
                name="trash-can"
                size="20px"
                containerClass="icon-trash-container"
                    onClick={() => this.toggleConfirmDelete(true, dataList.id, dataList.uploadTypeId)}
            />
        </div>
    );

    handleLoadMore = () => {
        this.setState(prevState => ({
            displayedItems: prevState.displayedItems + DISPLAY_ITEM.five
        }));
    }

    toggleErrorModal = (isShow, data = []) => {
        const { errorModal } = this.state.errorModal;

        this.setState({
            errorModal: {
                ...errorModal,
                show: isShow,
                data: data
            }
        });

        if (isShow == false) {
            const { resetErrorDetails } = this.props;
            resetErrorDetails();
        }
    }

    // upload error function
    toggleErrorUpload = (isShow, data = []) => {
        const { errorUpload } = this.state.errorUpload;

        this.setState({
            errorUpload: {
                ...errorUpload,
                show: isShow,
                data: data
            }
        });

        if (isShow == false) {
            const { resetErrorDetails } = this.props;
            resetErrorDetails();
        }
    }

    toggleConfirmDelete = (isShow, dataId = 0, uploadTypeId = 0) => {
        const { confirmDeleteModal } = this.state;

        this.setState({
            confirmDeleteModal: {
                ...confirmDeleteModal,
                show: isShow,
                dataId: dataId,
                uploadTypeId: uploadTypeId
            }
        });
    }

    handleConfirmDelete = async (okCancel) => {
        const { deleteHeaderNotification } = this.props;
        const { confirmDeleteModal } = this.state;

        if (CONFIRMATION_VALUE.Ok === okCancel) {
            this.setState({
                confirmDeleteModal: {
                    ...confirmDeleteModal,
                    isDeleting: true
                }
            });

            await deleteHeaderNotification(confirmDeleteModal.dataId, confirmDeleteModal.uploadTypeId);
        }

        this.setState({
            confirmDeleteModal: {
                ...confirmDeleteModal,
                show: false,
                dataId: 0,
                isDeleting: false
            }
        });
    }

    enableUploadButton=(value)=>{
        if(value === Selected_Index.i_One) {
            this.setState({
                showUploadButton: true
            });
        } else {
            this.setState({
                showUploadButton: false
            });
        }

        this.props.resetErrorDetails();
    }

    disableExtractButton = (error) => {
        if (!Array.isArray(error) || error.length === 0) {
            return true;
        }

        return !error.map(item => item.ErrorType).filter(Boolean).some(type => HR_UPLOAD_TEMPLATE_ERRORS.includes(type));
    }

    handleUploadButton=()=>{
        const getURL = `${ROUTE_LINK_LOCATION.invoiceUpload}?tab=chargeMapping`;
        window.open(getURL, "_blank")      
    }

    activeListTab = (listTab) => {
        const { disputeDetailsId, isSingleTabWithExtract } = this.props;

        if (isSingleTabWithExtract) {
            return listTab.filter(item => item.id === Selected_Index.i_Zero);
        } else {
            return listTab.map(item => {
                var disabled = item.disable;
                if ((item.id == Selected_Index.i_One || item.id == Selected_Index.i_Two) && disputeDetailsId > 0) {
                    disabled = false;
                }

                return {
                    ...item,
                    disable: disabled
                };
            })
        }
    }

    toggleViewError = (data) => {
        const { viewError } = this.props;
        this.setState({
            uploadTypeId: data.uploadTypeId,
            batchId: data.batchId
        })
        if (data.uploadTypeId == UPLOAD_TYPES.InvoiceMatchAudit){
            this.toggleErrorModal(true, data);
            viewError(data.id, data.uploadTypeId, 0);
        }
        else if (data.uploadTypeId == UPLOAD_TYPES.InvoiceUpload) {
            this.toggleErrorUpload(true, data);
            viewError(data.batchId, data.uploadTypeId, 0, null, null, true);
        }
        else if (data.uploadTypeId == UPLOAD_TYPES.ChargeTypeUpload) {
            this.toggleErrorModal(true, data);
            viewError(data.batchId, data.uploadTypeId, 0, null, null, false);
        }
        else if (data.uploadTypeId == UPLOAD_TYPES.RateCardUpload) {
            this.toggleErrorModal(true, data);
            viewError(data.batchId, data.uploadTypeId, 0, null, null, false);
        }
        else if (data.uploadTypeId == UPLOAD_TYPES.DebitorUpload) {
            this.toggleErrorModal(true, data);
            viewError(data.batchId, data.uploadTypeId, 0, null, null, false);
        }
        else if (data.uploadTypeId == UPLOAD_TYPES.ArticleUpload) {
            this.toggleErrorModal(true, data);
            viewError(data.batchId, data.uploadTypeId, 0, null, null, false);
        }
        else if (data.uploadTypeId == UPLOAD_TYPES.CircuitWireless) {
            this.toggleErrorModal(true, data);
            viewError(data.batchId, data.uploadTypeId, 0, null, null, false);
        }
        else if (data.uploadTypeId == UPLOAD_TYPES.HrUpload) {
            this.toggleErrorUpload(true, data);
            viewError(data.batchId, data.uploadTypeId, 0, null, null, false);
        }
        else if (data.uploadTypeId == UPLOAD_TYPES.RechargeMappingInventory) {
            this.toggleErrorModal(true, data);
            viewError(data.batchId, data.uploadTypeId, 0);
        }
        else if (data.uploadTypeId == UPLOAD_TYPES.RechargingOutputRecordGeneration) {
            this.toggleErrorModal(true, data);
            viewError(data.batchId, data.uploadTypeId, 0);
        }
        else if (data.uploadTypeId == UPLOAD_TYPES.RechargingOutputGeneration) {
            this.toggleErrorModal(true, data);
            viewError(data.batchId, data.uploadTypeId, 0, 
                        data.statusData.key.toLowerCase() ==="completedwitherror" 
                            ? "completedwitherror" 
                            : 
                        '');          
        }
    }

    handlePaginationAction = (index) => {
        const { errorModal } = this.state;

        if (errorModal.data.uploadTypeId == UPLOAD_TYPES.ChargeTypeUpload || errorModal.data.uploadTypeId == UPLOAD_TYPES.RateCardUpload ||
            errorModal.data.uploadTypeId == UPLOAD_TYPES.HrUpload || errorModal.data.uploadTypeId == UPLOAD_TYPES.CircuitWireless || errorModal.data.uploadTypeId == UPLOAD_TYPES.RechargingOutputGeneration) {
            this.props.viewError(errorModal.data.batchId, errorModal.data.uploadTypeId, index, errorModal.data.statusData.key.toLowerCase() === "completedwitherror"
                ? "completedwitherror"
                :
                '',
                null, null, false);
        }
    }

    handlePaginationActionTab1 = (index) => {
        const { errorUpload } = this.state;

        this.props.viewError(errorUpload.data.batchId, errorUpload.data.uploadTypeId, index);
    }

    handlePaginationActionTab2 = (index) => {
        const { errorUpload } = this.state;

        this.props.viewError(errorUpload.data.batchId, UPLOAD_TYPES.ChargeTypeUpload, index);
    }

    handleColumnClick2 = (columnName, isSortAsc) => {
        const { errorUpload } = this.state;

        this.props.viewError(errorUpload.data.batchId, UPLOAD_TYPES.ChargeTypeUpload, 0, columnName, isSortAsc);
    }

    handleExtractClick2 = () => {
        const { errorUpload } = this.state;
        if (errorUpload.data.uploadTypeId == UPLOAD_TYPES.HrUpload) {
            this.props.extractHrUploadErrorDetail(errorUpload.data.batchId);
        }       
        else {
            this.props.extractChargeMappingErrorDetail(errorUpload.data.batchId);
        }
    }

    handleExtractBtn = () => {
        const { batchId, errorModal } = this.state;
        const confirmationMessage = this.toLocaleLanguage('export_alert_message');
        if (parseInt(this.state.uploadTypeId) === parseInt(UPLOAD_TYPES.RechargingOutputGeneration)) {
            if (window.confirm(confirmationMessage)) {
                this.props.extractRechargeOutputGenErrorDetail(batchId,errorModal.data.subTitleData.value);
            }
        }
        else
             if (window.confirm(confirmationMessage)) {
                this.props.extractCircuitWirelessErrorDetail(batchId);
             }
    }

    toLocaleLanguage = (key) => {
            const { locale } = this.props;
            if (locale === null || locale === '' || locale === undefined)
                return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];
    
            return TRANSLATIONS[locale][key];
        }

    renderErrorModalTitle(uploadTypeId) {
        switch (uploadTypeId) {
            case UPLOAD_TYPES.InvoiceMatchAudit:
                return "Invoice Match/Audit Error Details";
            case UPLOAD_TYPES.ChargeTypeUpload:
                return "Charge Mapping Error Details";
            case UPLOAD_TYPES.RateCardUpload:
                return "Rate Card Error Details"; 
            case UPLOAD_TYPES.CircuitWireless:
                return "Upload Error Details"; 
            case UPLOAD_TYPES.DebitorUpload:
            case UPLOAD_TYPES.HrUpload:
            case UPLOAD_TYPES.ArticleUpload:
                return "Upload Error Details";
            case UPLOAD_TYPES.RechargeMappingInventory:
                return "Recharging Inventory Mapping Error Details";
            case UPLOAD_TYPES.RechargingOutputGeneration:
                return `Recharging Output Generation Error`;
            case UPLOAD_TYPES.RechargingOutputRecordGeneration:
                return `Recharging Generate Output Record Error Details`;
            default:
                return "Error Details";
        }
    }

    loading = () => {
        return (
            <div className="notification-view-error-loading">
                <NoSubscription />
            </div>
        );
    }

     handleCloseFormModal = () => {
        this.setState({ showModalForm: false})
    }

    render() {
        const { displayedItems, errorModal, confirmDeleteModal,errorUpload, showUploadButton, uploadTypeId, 
                 modalTitle, showModalForm, selectedRecordData, modalIsLoading } = this.state;
        const { data, errorDetails } = this.props;
        const hasMoreItems = data && data.length > displayedItems;

        const isChargeMapping = this.state.uploadTypeId === UPLOAD_TYPES.ChargeTypeUpload;

        return (
            <>
                <div className='header-notification' ref={this.wrapperRef}>
                    <div className='header-notification__title-container'>
                        <h1 className={`header-notification__title ${data <= 0 ? "header-notifcation__no-data" : ""}`}>
                            {data?.length > 0 ? "Notifications" : "No Available Notification"}
                        </h1>
                    </div>
                    <div className='header-notification__container'>
                        <div>
                            {this.props.data && this.props.data.slice(0, displayedItems).map((dataList, index) => (
                                <div key={index}>
                                    <div className="horizontal-separator"></div>
                                    <div className='header-notification__body'>
                                        <div className='header-notification__status-icon'>
                                            <Icons
                                                customClassName="icon-header-check-reg"
                                                name={this.getStatusIconName(dataList.statusData.key)}
                                                size="35px"
                                                containerClass="icon-circle-check-container"
                                            />
                                        </div>
                                        <div className='header-notification__info-container'>
                                            <h2 className='header-notification__body-title'>{dataList.title}</h2>
                                            {this.renderNotificationDetail(dataList)}
                                            {this.renderNotificationStatus(dataList)}
                                            <div className='header-notification__date'><span><FormatDateComponent date={dataList.date} /></span></div>
                                        </div>
                                        {this.renderDeleteIcon(dataList)}
                                    </div>
                                </div>
                            ))}
                            {hasMoreItems && (
                                <div className='view-more__container'>
                                    <Button className="view-button view-more-btn" onClick={this.handleLoadMore}>View More</Button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <ConfirmationNotificationModal
                    show={confirmDeleteModal.show}
                    customClass="comment-notification-modal modal-text-bold"
                    title={'Delete'}
                    handleModal={this.handleConfirmDelete}
                    message={MODAL_CUSTOM_MESSAGE.delete}
                    disabled={confirmDeleteModal.isDeleting}
                />

                <DetailsModal showModal={errorModal.show} customClassName="upload-error-modal" handleClose={() => { this.toggleErrorModal(false) }} title={this.renderErrorModalTitle(errorModal.data.uploadTypeId) } size={"xl"}>
                    <div className="data-table data-table__ok-button">
                        { !errorDetails.isLoading ?
                            errorModal.data.uploadTypeId == UPLOAD_TYPES.InvoiceMatchAudit ?
                                <TablePagination
                                    key="table-pagination-key"
                                    errorDetails={errorDetails}
                                    columns={errorDetails.matchAudit.Headers ?? []}
                                    pageList={errorDetails.matchAudit.Data ?? []}
                                    onColumnSearch={() => { }}
                                    onColumnSearchChange={() => { }}
                                    isColSearchShow={false}
                                    resizePage={() => { }}
                                    isNotSortable={true}
                                    isLoading={false}
                                    totalPage={0}
                                    paginationHidden={true}
                                /> 
                            :
                            <div className="notification-with-extract__container">
                                {
                                    Object.values(HAS_LIST_TAB).includes(this.state.uploadTypeId) &&
                                    <ListTabButton listData={this.activeListTab(this.state.listTab)} selectedIndex={this.state.selectedIndex} FilterIndex={this.FilterIndex} />
                                }
                               
                               {
                                    (Object.values(NOTIFICATION_HAVE_EXTRACT).includes(this.state.uploadTypeId)
                                        &&
                                        this.state.uploadTypeId === NOTIFICATION_HAVE_EXTRACT.RechargingOutputGeneration &&
                                        errorModal.data.statusData?.key?.toLowerCase() === "completedwitherror"
                                    ) &&
                                        <ButtonIcon
                                            isDisable={errorDetails.upload.Data.length === 0}
                                            onClick={this.handleExtractBtn}
                                            iconLeft="cloud-arrow-down"
                                            iconSize="17px"
                                            customClassName="header-option-list header-filter-button"
                                            labelName="Extract List"
                                        />
                                }
                               
                                <div className={`${Object.values(TWO_COLUMN_UPLOAD_COLUMN).includes(uploadTypeId) ? '' : 'notification-upload-table'}`}>
                                    <TablePagination
                                        key="table-pagination-key-upload"
                                        errorDetails={errorDetails}
                                        columns={isChargeMapping ? errorDetails.chargeMapping.Headers : errorDetails.upload.Headers ?? []}
                                        pageList={isChargeMapping ? errorDetails.chargeMapping.Data : errorDetails.upload.Data ?? []}
                                        pages={isChargeMapping ? errorDetails.chargeMapping.Pagination : errorDetails.upload.Pagination}
                                        paginationAction={this.handlePaginationAction}
                                        onColumnSearch={() => { }}
                                        onColumnSearchChange={() => { }}
                                        isColSearchShow={false}
                                        resizePage={() => { }}
                                        isNotSortable={true}
                                        isLoading={false}
                                        paginationHidden={errorDetails.upload.Pagination?.TotalPages > 1 ? false : true}
                                    /> 
                                </div>
                            </div>                                
                         : this.loading()
                            }
                        { !errorDetails.isLoading ? 
                            <ButtonIcon onClick={() => { this.toggleErrorModal(false) }} customClassName="header-option-list header-filter-button" labelName={Object.values(HAS_LIST_TAB).includes(this.state.uploadTypeId) ? "Cancel" : "OK"} />
                        : "" }
                    </div>
                </DetailsModal>
                {/* upload error modal */}
                <DetailsModal showModal={errorUpload.show} customClassName="upload-error-modal" handleClose={() => { this.toggleErrorUpload(false) }} title={"Upload Error Details"} size={"xl"}>
                    <div className="data-table data-table__ok-button">
                        <UploadNotification
                            key="table-pagination-key"
                            errorDetails={errorDetails}
                            paginationActionTab1={this.handlePaginationActionTab1}
                            paginationActionTab2={this.handlePaginationActionTab2}
                            columnClick2={this.handleColumnClick2}
                            enableUploadButton={this.enableUploadButton}
                            clickExtract2={this.handleExtractClick2}
                            isSingleTabWithExtract={errorUpload.data.uploadTypeId == UPLOAD_TYPES.HrUpload ?? false}
                            isExtractButtonDisabled={this.disableExtractButton(errorDetails.upload.Data.Items)}
                        />
                        { !errorDetails.isLoading ? 
                            <ButtonIcon isDisable={showUploadButton? errorDetails.chargeMapping.Data.Items.length == 0?  true : false : false} 
                                        onClick={() => { showUploadButton ? this.handleUploadButton() : this.toggleErrorUpload(false) }} 
                                        customClassName="header-option-list header-filter-button" 
                                        labelName={showUploadButton ? "Update Charge Mapping" : "Cancel"} />
                        : "" }
                    </div>
                </DetailsModal>
                 <ModalContainer
                        title={modalTitle}
                        show={showModalForm}
                        handleModal={this.handleCloseFormModal}
                        hideBtn={true}                                        
                        customClass=""
                        noTranslation                                        
                    >

                        <div>
                            <OutputRecordsInfo 
                                isLoading={modalIsLoading}
                                recordData={selectedRecordData}
                            />
                        </div>

                </ModalContainer>
            </>
        );
    }
}

export default connect(
    state => {
        const { errorDetails, outputRecord,attachFile } = state.notification;
        return {
            errorDetails,
            outputRecord,
            attachFile
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, notificationActions, OutputRecordAction),
        dispatch
    )
)(HeaderNotification);
